<template>
  <table class="table table-bordered">
    <thead class="thead-dark">
      <tr>
        <th class="text-center">ID</th>
        <th class="text-center">Litres</th>
        <th class="text-center">Price Per Litre</th>
        <th class="text-center">Total Cost</th>
        <th class="text-center">Odometer KMs</th>
        <th class="text-center">Timestamp</th>
        <th class="text-center">Location</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="refill in refills" :key="refill.id">
        <td>{{ refill.id }}</td>
        <td>{{ refill.litres }}</td>
        <td>{{ refill.pricePerLitre }}</td>
        <td>{{ refill.totalCost }}</td>
        <td>{{ refill.odometerKms }}</td>
        <td>{{ refill.timestamp }}</td>
        <td>
          <a v-if="refill.location" class="btn btn-primary" :href="`http://maps.google.com/?q=${refill.location.lat},${refill.location.lng}`" target="_blank"
            >Open Map <i class="bi bi-geo-alt-fill"></i
          ></a>
          <span v-else>No Location</span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { apiClient } from '../../helpers/api-client';
import { HTTP_METHODS, HTTP_STATUS_CODES } from '../../helpers/config';

export default {
  name: 'RefillsView',
  setup() {},
  data() {
    return {
      refills: []
    };
  },
  async created() {
    const vehicleId = this.$route.params.id;
    await this.loadRefills(vehicleId);
  },
  methods: {
    loadRefills: async function (vehicleId) {
      const result = await apiClient(`vehicles/${vehicleId}/refills`, HTTP_METHODS.GET);
      if (result.status === HTTP_STATUS_CODES.SUCCESS) {
        this.refills = result.data.sort(function (a, b) {
          return new Date(b.timestamp) - new Date(a.timestamp);
        });
      }
    }
  }
};
</script>
